import {useFlags, useFlagsLoaded} from '@product-web/flags'
import {useUser} from '@product-web/user'

import {bff} from './bff-hooks'

export const useCompanyOnboardingStatus = () => {
    const {isPenguinsMilestone1Live} = useFlags()
    const flagsLoaded = useFlagsLoaded()
    const user = useUser()

    const isOwner = user?.role === 'owner'

    const {data} = bff.featureOnboarding.companyOnboarding.getIsCompanyOnboardingComplete.useQuery(
        {
            isPenguinsMilestone1Live,
        },
        {
            enabled: flagsLoaded && isOwner,
        },
    )

    if (!isOwner) {
        return {
            awaitingCompanyOnboardingStatus: false,
            hasFinishedCompanyOnboarding: true,
        }
    }

    return {
        awaitingCompanyOnboardingStatus: !data,
        hasFinishedCompanyOnboarding: data?.hasFinishedCompanyOnboarding,
    }
}
